// Rol etiketleri ve rozet renkleri (Kullanıcı Yönetimi ile ortak)
export const ROLE_LABELS = {
  super_admin: { label: 'Süper Admin', color: 'bg-purple-100 text-purple-700' },
  location_manager: { label: 'Lokasyon Yöneticisi', color: 'bg-blue-100 text-blue-700' },
  isg_expert: { label: 'İSG Uzmanı', color: 'bg-emerald-100 text-emerald-700' },
  '2_onayci': { label: '2. Onaycı', color: 'bg-indigo-100 text-indigo-700' },
  viewer: { label: 'Görüntüleyici', color: 'bg-slate-100 text-slate-700' },
  firma_yetkilisi: { label: 'Firma Yetkilisi', color: 'bg-orange-100 text-orange-700' },
  magaza_yetkilisi: { label: 'Mağaza/Kiracı Yetkilisi', color: 'bg-sky-100 text-sky-700' },
  user: { label: 'Kullanıcı', color: 'bg-amber-100 text-amber-700' }
};
